import { render, staticRenderFns } from "./AgreementLink.vue?vue&type=template&id=f61d70ba&scoped=true"
import script from "./AgreementLink.vue?vue&type=script&lang=js"
export * from "./AgreementLink.vue?vue&type=script&lang=js"
import style0 from "./AgreementLink.vue?vue&type=style&index=0&id=f61d70ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61d70ba",
  null
  
)

export default component.exports